import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { MaintenanceResponseModel } from '@shared/models/maintenance.model';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private readonly http = inject(HttpClient);

  // Fetched once per app load and shared by the guards and AppComponent
  private readonly maintenanceModeEnabled$: Observable<boolean> = environment.maintenanceUrl
    ? this.http.get<MaintenanceResponseModel>(environment.maintenanceUrl).pipe(
        map((data) => data?.maintenanceModeEnabled === true),
        // If the config can't be fetched, don't lock users out of the app
        catchError(() => of(false)),
        shareReplay(1),
      )
    : of(false);

  isMaintenanceModeEnabled(): Observable<boolean> {
    return this.maintenanceModeEnabled$;
  }
}
